import * as Sentry from '@sentry/angular';
import { environment } from '../../../environments/environment';

if (isSentryAvailable()) {
    Sentry.init({
        dsn: environment.tpl.sentryDsn,
        environment: environment.tpl.sentryEnvironment,
    });
}

function isSentryAvailable(): boolean {
    return (
        Boolean(environment.tpl.sentryDsn) &&
        window.location.hostname !== 'localhost'
    );
}
